function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M68.0972 49.0008L78.6256 60.9174L92.7829 69.8763L95.2515 49.0741L92.7829 28.7363L78.3541 36.6074L68.0972 49.0008Z",
  fill: "#00832D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 67.944V85.6662C7 89.7179 10.3141 92.9996 14.4057 92.9996H32.3029L36.0057 79.604L32.3029 67.944L20.0217 64.2773L7 67.944Z",
  fill: "#0066DA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.3029 5L7 30.0556L20.0217 33.7222L32.3029 30.0556L35.944 18.5544L32.3029 5Z",
  fill: "#E94235"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.3029 30.0547H7V67.9436H32.3029V30.0547Z",
  fill: "#2684FC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.952 15.6099L92.7827 28.7366V69.8766L109.026 83.0644C111.457 84.9466 115.012 83.2294 115.012 80.1677V18.4455C115.012 15.3472 111.377 13.6483 108.952 15.6099ZM68.097 49.001V67.9455H32.3027V93.001H85.377C89.4687 93.001 92.7827 89.7194 92.7827 85.6677V69.8766L68.097 49.001Z",
  fill: "#00AC47"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.377 5H32.3027V30.0556H68.097V49L92.7827 28.7478V12.3333C92.7827 8.28167 89.4687 5 85.377 5Z",
  fill: "#FFBA00"
}));

var SvgMeet = function SvgMeet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 99,
    viewBox: "0 0 122 99",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMeet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/meet.ee0dbd71.svg";
export { ForwardRef as ReactComponent };